var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "viq-conv-item",
      class: { "viq-conv-item--active": _vm.active },
      on: {
        click: function ($event) {
          return _vm.$emit("select")
        },
        contextmenu: function ($event) {
          $event.preventDefault()
          return _vm.showContextMenu.apply(null, arguments)
        },
      },
    },
    [
      !_vm.editing
        ? _c("div", { staticClass: "viq-conv-item__content" }, [
            _c("div", { staticClass: "viq-conv-item__text" }, [
              _c(
                "span",
                {
                  staticClass: "viq-conv-item__title",
                  attrs: { title: _vm.conversation.title },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.conversation.title || "Untitled") +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "viq-conv-item__time" }, [
                _vm._v(_vm._s(_vm.timeAgo)),
              ]),
            ]),
          ])
        : _c(
            "div",
            {
              staticClass: "viq-conv-item__edit",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.renameValue,
                    expression: "renameValue",
                  },
                ],
                ref: "renameInput",
                staticClass: "viq-conv-item__edit-input",
                domProps: { value: _vm.renameValue },
                on: {
                  keyup: [
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.confirmRename.apply(null, arguments)
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k(
                          $event.keyCode,
                          "escape",
                          undefined,
                          $event.key,
                          undefined
                        )
                      )
                        return null
                      return _vm.cancelRename.apply(null, arguments)
                    },
                  ],
                  blur: _vm.confirmRename,
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.renameValue = $event.target.value
                  },
                },
              }),
            ]
          ),
      _vm._v(" "),
      !_vm.editing
        ? _c(
            "div",
            {
              staticClass: "viq-conv-item__actions",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c(
                "button",
                {
                  staticClass: "viq-conv-item__action",
                  attrs: { title: "Rename" },
                  on: { click: _vm.startRename },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M8.5 1.5l2 2-7 7H1.5V8.5l7-7z",
                          stroke: "currentColor",
                          "stroke-width": "1",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "viq-conv-item__action viq-conv-item__action--delete",
                  attrs: { title: "Delete" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("delete")
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M1.5 3h9M4.5 3V1.5h3V3M9.5 3v7.5h-7V3",
                          stroke: "currentColor",
                          "stroke-width": "1",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }